import { useEffect } from 'react';

const THEME_CLASS = 'app-theme';

let themeMountCount = 0;

/**
 * Adds `app-theme` to <html> while a themed layout (auth / dashboard) is mounted.
 * Ref-counted so nested shells (e.g. ProjectSelectionScreen + DashboardShell) do not
 * strip the class when one child unmounts.
 */
export function useAppTheme() {
  useEffect(() => {
    themeMountCount += 1;
    document.documentElement.classList.add(THEME_CLASS);
    return () => {
      themeMountCount = Math.max(0, themeMountCount - 1);
      if (themeMountCount === 0) {
        document.documentElement.classList.remove(THEME_CLASS);
      }
    };
  }, []);
}
